import React, { useEffect, useState } from 'react';
import { QUERY_NOTIFICATIONS } from '../../../graphql/query/notifications/getNotifications';
import { useQuery } from '@apollo/client';
import { IconButton } from 'components/atoms/Buttons/IconButton';
import { QueryNotificationsQuery } from '../../../graphql/generated/graphql';
import { ErrorContainer } from '../Error/ErrorContainer';
import NotificationsView from './Notification.view';
import { useSelector } from 'react-redux';
import { getUserNotifications } from '../../../store/selectors/user/user.selectors';
import { Notification } from '../../../types/notifications/notification.def';

const Notifications = () => {
  const userReadNotifications = useSelector(getUserNotifications);
  const [notifications, setNotifications] = useState<Notification[] | null>(
    null
  );
  const [unReadNotifications, setUnReadNotifications] = useState<
    Notification[] | null
  >(null);
  const [readNotifications, setReadNotifications] = useState<
    Notification[] | null
  >(null);
  const [showReadNotifications, setShowReadNotifications] = useState<boolean>(
    false
  );
  const [unReadNotificationCount, setUnReadNotificationsCount] = useState<
    number
  >(0);

  const { error, loading } = useQuery<QueryNotificationsQuery>(
    QUERY_NOTIFICATIONS,
    {
      onCompleted: data => {
        setNotifications(
          data?.notifications?.data?.map(notif => ({
            id: notif.id,
            ...notif.attributes
          }))
        );
      }
    }
  );

  useEffect(() => {
    setUnReadNotifications(
      notifications?.filter(
        notif =>
          !userReadNotifications?.includes(notif?.id) && notif?.hidden === false
      )
    );
    setReadNotifications(
      notifications?.filter(
        notif =>
          userReadNotifications?.includes(notif?.id) && notif?.hidden === false
      )
    );
  }, [notifications]);

  useEffect(() => {
    setUnReadNotificationsCount(
      notifications?.filter(
        notif =>
          !userReadNotifications?.includes(notif?.id) && notif?.hidden === false
      )?.length
    );
  }, [notifications, userReadNotifications]);

  if (loading)
    return <IconButton icon={'Bell'} onClick={null} notificationsCount={0} />;
  if (error) {
    return (
      <ErrorContainer
        text={'Problème de récupération des notifications'}
        hideButton={true}
      />
    );
  }

  return (
    <NotificationsView
      readNotifications={readNotifications}
      unReadNotifications={unReadNotifications}
      unReadNotificationsCount={unReadNotificationCount}
      showReadNotifications={showReadNotifications}
      setShowReadNotifications={setShowReadNotifications}
    />
  );
};
export default Notifications;
